<template>
  <div
    class="vc-section vc-card vc-card--compact vc-memory-enabled"
    :class="{ 'vc-memory-enabled--collapsed': !callControl.memory_enabled }"
  >
    <div class="vc-memory-enabled__head">
      <span class="vc-memory-enabled__title">插入记忆</span>
      <div class="vc-memory-enabled__switch">
        <span class="vc-memory-enabled__switch-label">{{
          callControl.memory_enabled ? '开启' : '关闭'
        }}</span>
        <i-switch v-model="callControl.memory_enabled" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemoryEnabledSection',
  props: {
    callControl: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.ensureShape()
  },
  methods: {
    ensureShape() {
      if (this.callControl.memory_enabled == null) {
        this.$set(this.callControl, 'memory_enabled', false)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './shared.scss';

.vc-section {
  margin-bottom: 16px;
}

.vc-card {
  background: #fff;
  border: 1px solid #e8eaec;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  padding: 20px;
}

.vc-card--compact {
  padding-bottom: 16px;
}

.vc-memory-enabled--collapsed {
  padding-bottom: 16px;

  .vc-memory-enabled__head {
    margin-bottom: 0;
  }
}

.vc-memory-enabled__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 24px;
}

.vc-memory-enabled__title {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
  line-height: 24px;
}

.vc-memory-enabled__switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.vc-memory-enabled__switch-label {
  font-size: 13px;
  color: #595959;
  line-height: 24px;
}
</style>
